  import React from "react";
import AppointmentsHistory from "../../AppointmentHistory";
import { IAppointmentsTabProps } from "../../interface";

const AppointmentTab: React.FC<IAppointmentsTabProps> = (_props) => {
  return <AppointmentsHistory />;
};

export default AppointmentTab;
